module.exports = __webpack_public_path__ + "static/media/bonus.86617e66.wav";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/sounds/bonus.wav
// module id = 60
// module chunks = 0